import Vue from "vue";

Vue.filter("uppercase", val => (val.length ? val.toUpperCase() : ""));
Vue.filter("capitalize", val =>
  val.length ? val.charAt(0).toUpperCase() + val.slice(1) : ""
);
Vue.filter("likes", val => (val > 0 ? `${val * 10}%` : "NA"));
Vue.filter("date_articles", val => val.substring(4, 15));
Vue.filter("truncate_250", val =>
  val.length > 250 ? `${val.substring(0, 250)}...` : val
);
Vue.filter("truncate_200", val =>
  val.length > 200 ? `${val.substring(0, 200)}...` : val
);
Vue.filter("truncate_140", val =>
  val.length > 140 ? `${val.substring(0, 140)}...` : val
);
Vue.filter("truncate_450", val =>
  val.length > 450 ? `${val.substring(0, 450)}...` : val
);
Vue.filter("truncate_20", val =>
  val.length > 20 ? `${val.substring(0, 20)}...` : val
);
Vue.filter("truncate_100", val =>
  val.length > 100 ? `${val.substring(0, 100)}...` : val
);
Vue.filter("percenet_filter", val =>
  val > 0 ? Math.round(val * 100) / 100 : val
);

Vue.filter("date_single_updates", val => {
  let a = val.substring(4, 15);
  return (
    a.substring(0, a.length - 5) + "," + a.substring(a.length - 5, a.length)
  );
});

Vue.filter("date_multiple_updates", val => {
  let a = val.releaseDate.substring(4, 15);
  let b = val.releaseDate2.substring(8, 10);
  return (
    a.substring(0, a.length - 5) +
    "-" +
    b +
    "," +
    a.substring(a.length - 5, a.length)
  );
});
